import { patientAccessTheme } from '@HomaHealth/ui-component-library';

const blueLight = {
  bar: '#4981CA',
  headerBg: '#EFF2F6',
  bg: '#EFF2F6',
  textColor: patientAccessTheme.palette.text.highemphasis,
};
const blueDark = {
  bar: '#4981CA',
  headerBg: '#4981CA',
  bg: '#EFF2F6',
  textColor: patientAccessTheme.palette.status.white,
};
const blueCard = { headerBg: '#6393D0', bg: '#4981CA' };
const brownLight = {
  bar: '#C88044',
  headerBg: '#F9F2EB',
  bg: '#F9F2EB',
  textColor: patientAccessTheme.palette.text.highemphasis,
};
const brownDark = {
  bar: '#C88044',
  headerBg: '#C88044',
  bg: '#F9F2EB',
  textColor: patientAccessTheme.palette.status.white,
};
const brownCard = { headerBg: ' #C88044', bg: '#B4733D' };
const greenLight = {
  bar: '#24A574',
  headerBg: '#EAFAF4',
  bg: '#EAFAF4',
  textColor: patientAccessTheme.palette.text.highemphasis,
};
const greenDark = {
  bar: '#24A574',
  headerBg: '#24A574',
  bg: '#EAFAF4',
  textColor: patientAccessTheme.palette.status.white,
};
const greenCard = { headerBg: '#24A574', bg: '#209468' };
const defaultColors = {
  bar: '#99ACC2',
  headerBg: '#F5F8FA',
  bg: '#F5F8FA',
  textColor: patientAccessTheme.palette.text.highemphasis,
};

const DeepDiveConstants = {
  TITLE: 'Deep Dive',
  ADD_TO_TASKBOARD: 'Add To Taskboard',
  TOTAL_COST: 'Total Cost',
  HEADER: 'Showing Percentage (%) and Amount of',
  CARD_COLORS_BY_IDENTIFIERS: {
    typeOfServiceCategory: { ...blueLight },
    typeOfServiceSubCategory: { ...blueDark },
    typeOfServiceSubFamily: { ...blueDark },
    procedure: { ...blueDark },
    diseasesICDLevel1: { ...blueLight },
    diseasesICDLevel2: { ...blueDark },
    diseasesICDLevel3: { ...blueDark },
    placeOfService: { ...blueLight },
    drugClass: { ...brownLight },
    drugSubClass: { ...brownDark },
    drugFamily: { ...brownDark },
    drugSubFamily: { ...brownDark },
    drugName: { ...brownDark },
    claims: { ...brownLight },
    members: { ...brownLight },
    providerSpecialty: { ...brownLight },
    billingProvider: { ...brownLight },
    providerName: { ...brownDark },
    ageBracket: { ...greenLight },
    age: { ...greenDark },
    locationState: { ...greenLight },
    locationCityZip: { ...greenDark },
    default: { ...defaultColors },
  },
  TOP_CARD_COLORS: {
    typeOfServiceCategory: { ...blueCard },
    typeOfServiceSubCategory: { ...blueCard },
    typeOfServiceSubFamily: { ...blueCard },
    procedure: { ...blueCard },
    diseasesICDLevel1: { ...blueCard },
    diseasesICDLevel2: { ...blueCard },
    diseasesICDLevel3: { ...blueCard },
    placeOfService: { ...blueCard },
    drugClass: { ...brownCard },
    drugSubClass: { ...brownCard },
    drugFamily: { ...brownCard },
    drugSubFamily: { ...brownCard },
    drugName: { ...brownCard },
    claims: { ...brownCard },
    members: { ...brownCard },
    providerSpecialty: { ...brownCard },
    billingProvider: { ...brownCard },
    providerName: { ...brownCard },
    ageBracket: { ...greenCard },
    age: { ...greenCard },
    locationState: { ...greenCard },
    locationCityZip: { ...greenCard },
    default: { ...defaultColors },
  },
  MODAL_TITLE: 'Cost Trend',
  CANCEL: 'Cancel',
  ADD_TO_TASK: 'Add Task for This',
  CURRENT_VALUE: 'Current Value',
  CHANGE: 'Change',
  PRIMARY_CATEGORY: 'Primary Category',
  AMOUNT: 'Amount',
  TOTAL_PERCENT: '% of Total',
  SEARCH: 'Search',
  CLOSE: 'Close',
  NO_DATE_FILTER: 'No filter on dates',
};

export default DeepDiveConstants;
